import { render } from "./CreateSale.vue?vue&type=template&id=dc987fb0&scoped=true"
import script from "./CreateSale.vue?vue&type=script&lang=js"
export * from "./CreateSale.vue?vue&type=script&lang=js"

import "./CreateSale.vue?vue&type=style&index=0&id=dc987fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc987fb0"]])

export default __exports__